<!-- -->
<template>
  <div>
  </div>
</template>

<script>
  export default {
    props:{
      src:{
        type:String,
        required: true
      }
    },
    name: 'voice',
    data () {
      return {}
    },
    mixins: [tableBase],
    methods: {},
    mounted () {
    }
  }
</script>

<style lang="less" scoped>

</style>
